import { LAYOUT } from '@admin/router/constant'

// GMP 红人运营
const GmpKolRouter = {
  path: '/gmp',
  name: '',
  component: LAYOUT,
  children: [
    // 红人开发
    {
      path: '/gmp/kol/influencer-development',
      name: 'GmpKolInfluencerDevelopment',
      component: () => import('@admin/views/gmp/kol/influencer-development/index.vue'),
      meta: {
        title: '红人开发',
      },
    },
    {
      path: '/gmp/kol/influencer-development/invitation',
      name: 'GmpKolInfluencerInvitation',
      component: () => import('@admin/views/gmp/kol/influencer-development/invitation/index.vue'),
      meta: {
        title: '意向邀约',
        hideMenu: true,
      },
    },
    {
      path: '/gmp/kol/influencer-development/invitation-log',
      name: 'GmpKolInfluencerInvitationLog',
      component: () =>
        import('@admin/views/gmp/kol/influencer-development/invitation-log/index.vue'),
      meta: {
        title: '邀约日志',
        hideMenu: true,
      },
    },
    // 红人池
    {
      path: '/gmp/kol/influencer-pool',
      name: 'GmpKolInfluencerPool',
      component: () => import('@admin/views/gmp/kol/influencer-pool/index.vue'),
      meta: {
        title: '红人池',
      },
    },
    {
      path: '/gmp/kol/influencer-pool/detail',
      name: 'GmpKolInfluencerPoolDetail',
      component: () => import('@admin/views/gmp/kol/influencer-pool/detail.vue'),
      meta: {
        title: '红人详情',
        hideMenu: true,
      },
    },
    // 邮件模版
    {
      path: '/gmp/kol/email-template',
      name: 'GmpKolEmailTemplate',
      component: () => import('@admin/views/gmp/kol/email-template/index.vue'),
      meta: {
        title: '邮件模版',
      },
    },
    {
      path: '/gmp/kol/email-template/edit',
      name: 'GmpKolEmailTemplateEdit',
      component: () => import('@admin/views/gmp/kol/email-template/edit.vue'),
      meta: {
        title: '编辑邮件模版',
        hideMenu: true,
      },
    },
    // 邮箱配置
    {
      path: '/gmp/kol/email-config',
      name: 'GmpKolEmailConfig',
      component: () => import('@admin/views/gmp/kol/email-config/index.vue'),
      meta: {
        title: '邮箱配置',
      },
    },
    // 标签管理
    {
      path: '/gmp/kol/tag-management',
      name: 'GmpKolTagManagement',
      component: () => import('@admin/views/gmp/kol/tag-management/index.vue'),
      meta: {
        title: '标签管理',
      },
    },
    // 红人账号
    {
      path: '/gmp/kol/influencer-member',
      name: 'GmpKolInfluencerMember',
      component: () => import('@admin/views/gmp/kol/influencer-member/index.vue'),
      meta: {
        title: '红人账号',
      },
    },
    {
      path: '/gmp/kol/influencer-member/edit',
      name: 'GmpKolInfluencerMemberEdit',
      component: () => import('@admin/views/gmp/kol/influencer-member/edit.vue'),
      meta: {
        title: '编辑红人信息',
        hideMenu: true,
      },
    },
    // 红人订单
    {
      path: '/gmp/kol/influencer-order',
      name: 'GmpKolInfluencerOrder',
      component: () => import('@admin/views/gmp/kol/influencer-order/index.vue'),
      meta: {
        title: '红人订单',
      },
    },
  ],
}

export default GmpKolRouter
